import NotificationPrefs from '../../components/account/NotificationPrefs';
import { GivingStatementCard } from '../../components/DonorWall';
import { AccountDeletion, BlockedMembers, MonthlyGiftLink } from '../../components/account/AccountSafety';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../hooks/use-toast';
import { Loader2, Save } from 'lucide-react';

const ProfilePage = () => {
  const { user, updateProfile } = useAuth();
  const { toast } = useToast();
  const [form, setForm] = useState({
    full_name: '', phone: '', avatar_url: '', language: 'en',
    address: { line1: '', city: '', state: '', country: '', pincode: '' },
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user) {
      setForm({
        full_name: user.full_name || '',
        phone: user.phone || '',
        avatar_url: user.avatar_url || '',
        language: user.language || 'en',
        address: user.address || { line1: '', city: '', state: '', country: '', pincode: '' },
      });
    }
  }, [user]);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await updateProfile(form);
      toast({ title: 'Profile updated ✨' });
    } catch (err) {
      toast({ title: 'Update failed', description: err?.response?.data?.detail || 'Try again.' });
    } finally { setSaving(false); }
  };

  return (
    <div className="max-w-3xl">
      <div className="eyebrow mb-2">Account</div>
      <h1 className="font-serif-display text-4xl text-burgundy">My <span className="font-italic-display text-rose-italic">Profile</span></h1>

      <form onSubmit={handleSave} className="mt-8 grid gap-6">
        <div className="grid md:grid-cols-2 gap-6">
          <Field label="Full Name" value={form.full_name} onChange={(v) => setForm({ ...form, full_name: v })} />
          <Field label="Phone" value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} required={false} />
        </div>
        <Field label="Avatar URL" value={form.avatar_url} onChange={(v) => setForm({ ...form, avatar_url: v })} required={false} />
        <Field label="Preferred Language" value={form.language} onChange={(v) => setForm({ ...form, language: v })} required={false} />

        <h3 className="font-serif-display text-2xl text-burgundy mt-4">Address</h3>
        <Field label="Address Line" value={form.address.line1} onChange={(v) => setForm({ ...form, address: { ...form.address, line1: v } })} required={false} />
        <div className="grid md:grid-cols-2 gap-6">
          <Field label="City" value={form.address.city} onChange={(v) => setForm({ ...form, address: { ...form.address, city: v } })} required={false} />
          <Field label="State" value={form.address.state} onChange={(v) => setForm({ ...form, address: { ...form.address, state: v } })} required={false} />
          <Field label="Country" value={form.address.country} onChange={(v) => setForm({ ...form, address: { ...form.address, country: v } })} required={false} />
          <Field label="Pincode" value={form.address.pincode} onChange={(v) => setForm({ ...form, address: { ...form.address, pincode: v } })} required={false} />
        </div>

        <div>
          <button type="submit" disabled={saving} className="pill-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Save Changes
          </button>
        </div>
      </form>
      <NotificationPrefs />
      <GivingStatementCard />
      <MonthlyGiftLink />
      <BlockedMembers />
      <AccountDeletion />
    </div>
  );
};

const Field = ({ label, value, onChange, required = true }) => (
  <label className="block">
    <span className="block text-xs uppercase tracking-[0.2em] text-mahogany/80 mb-2">{label}</span>
    <input value={value} onChange={(e) => onChange(e.target.value)} required={required}
      className="w-full bg-transparent border-b border-mahogany/30 pb-3 pt-1 text-burgundy focus:outline-none focus:border-mahogany transition-colors" />
  </label>
);

export default ProfilePage;
